export const API_URL = 'https://backend.picular.co/api'
